import { useState, useEffect } from 'react';
import { getCollection } from '../../services/firestoreService';
import { getAllSubscriptions } from '../../services/subscriptionService';

interface User {
  id: string;
  email?: string;
  displayName?: string;
  createdAt?: any;
  lastSeen?: any;
}

const UsersTab: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const loadData = async () => {
      try {
        let usersData: User[];
        try {
          usersData = await getCollection<User>('users', undefined, 'createdAt', 'desc', 10000);
        } catch (_orderError) {
          usersData = await getCollection<User>('users', undefined, undefined, undefined, 10000);
        }
        setUsers(usersData);

        const subsData = await getAllSubscriptions();
        setSubscriptions(subsData);
      } catch (error) {
        console.error('Error loading users:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const getUserSubscription = (userId: string) => {
    return subscriptions.find((sub) => sub.userId === userId);
  };

  const filteredUsers = users.filter((user) => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      user.email?.toLowerCase().includes(search) ||
      user.displayName?.toLowerCase().includes(search) ||
      user.id.toLowerCase().includes(search)
    );
  });

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading users...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.75rem', fontWeight: 'bold' }}>Users</h1>
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '0.5rem 1rem',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: '300px',
          }}
        />
      </div>

      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #e0e0e0' }}>
              <th style={{ padding: '1rem', textAlign: 'left' }}>User ID</th>
              <th style={{ padding: '1rem', textAlign: 'left' }}>Email</th>
              <th style={{ padding: '1rem', textAlign: 'left' }}>Name</th>
              <th style={{ padding: '1rem', textAlign: 'left' }}>Subscription</th>
              <th style={{ padding: '1rem', textAlign: 'left' }}>Platform</th>
              <th style={{ padding: '1rem', textAlign: 'left' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.slice(0, 100).map((user) => {
              const subscription = getUserSubscription(user.id);
              return (
                <tr key={user.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '1rem', fontSize: '0.875rem', wordBreak: 'break-all' }}>{user.id || 'N/A'}</td>
                  <td style={{ padding: '1rem' }}>{user.email || 'N/A'}</td>
                  <td style={{ padding: '1rem' }}>{user.displayName || 'N/A'}</td>
                  <td style={{ padding: '1rem' }}>
                    {subscription ? subscription.planId : 'Free'}
                  </td>
                  <td style={{ padding: '1rem' }}>
                    {subscription ? subscription.platform : '-'}
                  </td>
                  <td style={{ padding: '1rem' }}>
                    <span style={{
                      padding: '0.25rem 0.5rem',
                      borderRadius: '4px',
                      backgroundColor: subscription?.status === 'active' ? '#d1fae5' : '#fee2e2',
                      color: subscription?.status === 'active' ? '#065f46' : '#991b1b',
                      fontSize: '0.875rem',
                    }}>
                      {subscription?.status || 'Free'}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {filteredUsers.length === 0 && (
        <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
          No users found
        </div>
      )}
    </div>
  );
};

export default UsersTab;

